/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PraticaOperatoreSummaryDTO } from './pratica-operatore-summary-dto';


export interface PraticaOperatoreDetailDTO { 
    summary?: PraticaOperatoreSummaryDTO;
    /**
     * Mappa dinamica chiave→valore (chiave-first): le chiavi sono le TipoPraticaAttributo.chiave del bando (= configurazione.formData del config tradotto). Include le sezioni strutturali \'anagrafica\' (oggetto) e \'nucleo\' (array). Non tipizzabile staticamente: la forma per-bando e\' data dal config tradotto.
     */
    form_data?: string;
}

